import { render } from "./InputRange.vue?vue&type=template&id=271bc8ed"
import script from "./InputRange.vue?vue&type=script&lang=js"
export * from "./InputRange.vue?vue&type=script&lang=js"

import "./InputRange.vue?vue&type=style&index=0&id=271bc8ed&lang=scss"

import exportComponent from "/app/widget-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__